export { Body, SmallBody, ButtonText, TypographyCaption, FontWeight, bodyFontSize, Span } from './Text'
export { Heading, SubHeading, SmallHeading, headingFontSize } from './Heading'
